import { Requests } from '@/services/request.service'
import { Configuration } from '@/entities/Configuration'
const requests = new Requests()

const state = {
  configuration: null,
  instanceId: null
}

const actions = {
  getConfiguration: ({ state, commit }) => {
    return new Promise((resolve, reject) => {
      requests.getConfiguration(state.instanceId).then((data) => {
        commit('setConfiguration', data)
        resolve(state.configuration)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  setInstanceId: (state, instanceId) => {
    state.instanceId = instanceId
    if (instanceId) {
      localStorage.setItem('instanceId', instanceId)
    } else {
      localStorage.removeItem('instanceId')
    }
  },
  setConfiguration: (state, configuration) => {
    state.configuration = new Configuration(configuration)
    document.title = `${state.configuration.name} || ${window.vm.$t('refunds')}`
  }
}

export default {
  state,
  actions,
  mutations
}
